<template>
  <div>
    <div v-if="!chapter">{{ $t("grammarGame.game-page.loading") }}</div>
    <div v-if="chapter" class="grammar-page">
      <!-- <div class="game-header">
        <h2 class="title">{{ chapter.title }}</h2>
      </div> -->
      <GameHeader
        :currentData="data"
        :externalData="externalData"
        :word="currentWord"
        :WIN="WIN"
        :status="status"
      />
      <!-- <OnBoardingModal
        v-if="currentGame"
        :text="currentGame.lesson.opening.text"
        :audioSrc="currentGame.lesson.opening.audio"
        :vidSrc="currentGame.lesson.opening.video"
        :imgSrc="currentGame.lesson.opening.image"
      /> -->
      <GameSummary
        v-if="isSummary"
        :msg="msg"
        :playedItems="currItems"
        :mistakes="mistakes"
        :currentData="data"
        :externalData="externalData"
        @restartGame="restartGame"
      />
      <div class="game-main" v-if="!isSummary">
        <div class="question" v-if="question">
          <transition name="slide-fade" mode="out-in">
            <span
              v-if="!question.onlyAudio"
              :key="question.qWord.eng"
              class="q"
            >
              {{ question.qWord.eng }}</span
            >
          </transition>
          <AudioBtn
            v-if="question.qWord.id"
            :urlId="question.qWord.id"
            :autoplay="autoPlay"
            :idx="idx"
          />
        </div>
        <ul class="answers grid" v-if="question">
          <li
            v-for="answer of question.answers"
            :key="answer.objectID"
            :class="{
              right: choosenId && question.qWord.objectID === answer.objectID,
              wrong:
                choosenId === answer.objectID &&
                question.qWord.objectID !== answer.objectID,
              nope: choosenId && question.qWord.objectID !== answer.objectID,
              rightword:
                choosenId && question.qWord.objectID === answer.objectID,
              damnright:
                choosenId && question.qWord.objectID === answer.objectID
            }"
            @click="checkAnswerA(answer, idx)"
          >
            {{ answer.heb }}
          </li>
        </ul>
      </div>
      <div class="actions-wrapper">
        <button v-if="showNext" class="btn-next" @click="nextQuestion">
          {{ $t("grammarGame.game-page.next_q") }}
        </button>
        <button v-if="submitting" class="btnSum">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </button>
        <button @click="showSummary" v-if="showResults" class="btnSum">
          {{ $t("grammarGame.game-page.summery") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import "./game-page.scss";
import { mapGetters } from "vuex";
import GameSummary from "./game-summary.vue";
import GameHeader from "./game-header.vue";
import ProgressBar from "../Shared/progressBar.vue";
import OnBoardingModal from "../onBoardingModal/OnBoardingModal.vue";
import AudioBtn from "../Shared/audioBtn.vue";
// import confetti from "canvas-confetti";
import { wordService } from "../../services/wordService";
import { userService } from "../../services/userService";
import { settingsService } from "../../services/settingsService";
const initializeState = {
  currItems: [],
  chapter: null,
  questions: [],
  question: null,
  WIN: 0,
  LOST: 0,
  idx: 0,
  showNext: false,
  isClicked: false,
  status: "",
  submitting: false,
  choosenId: "",
  isSummary: false,
  showResults: false,
  results: [],
  onlyArbT: false,
  msg: "",
  savedWords: [],
  courseData: null,
  currentWord: null,
  mistakes: [],
  updateUser: null,
  soundSetting: [],
  isStop: false,
  autoPlay: true,
  externalData: null,
};
export default {
  name: "grammar-game",
  props: ["data"],
  data() {
    return {
      ...initializeState
    };
  },
  computed: {
    ...mapGetters(["words", "chapters", "user", "grammarLaws"]),
    currentGame() {
      return this.$store.getters.currentGame;
    }
  },
  async created() {
    console.log(this.currentGame);
    this.soundSetting = await settingsService.getSettings();
    this.externalData = this.$route.query;
    console.log(this.externalData);
    this.init();
  },
  watch: {
    $route(to, from) {
      this.init();
    },
    currentGame() {
      this.courseData = this.currentGame;
    },
    question() {
      this.currentWord = this.question;
    },
    grammarLaws() {
      this.init();
    },
    updateUser() {
      this.$store.commit("setUser", this.updateUser);
    },
    soundSetting() {
      if (this.soundSetting && this.soundSetting.length) {
        this.isStop = this.soundSetting[0];
        this.autoPlay = this.soundSetting[1];
      }
    }
  },
  methods: {
    async init() {
      (this.currItems = []),
        (this.chapter = null),
        (this.questions = []),
        (this.idx = 0),
        (this.showNext = false),
        (this.isClicked = false),
        (this.status = ""),
        (this.choosenId = ""),
        (this.isSummary = false),
        (this.showResults = false),
        (this.results = []),
        (this.WIN = 0),
        (this.LOST = 0),
        (this.mistakes = []);
      this.savedWords = [];
      const { id, gameid } = this.$route.params;

      if (this.data) {
        this.currItems = this.grammarLaws.filter(
          w => w.grammar === this.data.game.algolia_game_id
        );
        console.log("curr", this.currItems);
      } else if (gameid) {
        this.currItems = this.grammarLaws.filter(w => w.grammar === gameid);
        console.log("curr", this.currItems);
      }

      this.chapter = {
        title: "משחק",
        questionsNumber: 10
      };

      this.generateQuestion();
    },
    playAudio(ev) {
      if (!this.isStop) return;
      // if (ev) {
      //   ev.stopPropagation();
      // }
      if (ev > 0 && ev < 9) {
        const audio = new Audio(
          require("../../assets/audio/VICTORY" + ev + ".mp3")
        );
        audio.play();
      } else if (ev === 0) {
        let audio;
        audio = new Audio(require("../../assets/audio/LOSS1.mp3"));
        if (this.LOST % 2 === 0)
          audio = new Audio(require("../../assets/audio/LOSS2.mp3"));
        audio.play();
      } else if (ev === 10) {
        const audio = new Audio(require("../../assets/audio/VICTORY-FULL.mp3"));
        audio.play();
      }
    },
    generateQuestion(lastWord = "") {
      const { type, grammar, id } = this.$route.params;
      const questions = [];
      let items = this.currItems;
      //this.currItems[0].know = 5;
      items = items.filter(item => item.objectID !== lastWord.objectID);
      console.log(items);
      const question = {
        qWord: this.getRandomWord(items, true),
        answers: [],
        // onlyAudio: Math.random() > 0.5 ? true : false
        onlyAudio: false
      };
      let answers = this.generateAnswer(
        question.qWord.exercise,
        "exercise",
        question.qWord
      );
      //remove the used word from items array
      answers = this.randomList(answers);
      question.answers = answers;
      questions.push(question);

      console.log(questions);
      this.questions = questions;
      this.playedItems = questions.map(q => q.qWord);
      this.question = question;
    },

    /*
    remove word from items array
     */
    removeWord(word, items) {
      const newItems = [];
      for (var i = 0; i < items.length; i++) {
        if (items[i] != word) {
          newItems.push(items[i]);
        }
      }
      return newItems;
    },
    getRandomWord(items = this.currItems, isQuestion = false, limit = 12) {
      const randomNumber = Math.floor(Math.random() * items.length);
      const ranWord = items[randomNumber];
      console.log(items, randomNumber, ranWord)
      if (ranWord) {
        if (ranWord.know >= 5 && isQuestion && limit > 0) {
          return this.getRandomWord(items, isQuestion, limit - 1);
        } else {
          return ranWord;
        }
      }
    },

    generateAnswer(family, kind, rightAnswer) {
      let filteredWords = this.currItems.filter(
        i => i.objectID !== rightAnswer.objectID
      );
      console.log("aaaa", filteredWords);
      filteredWords = filteredWords.filter(i => i[kind] === family);
      console.log("Filtered", filteredWords);
      const answers = [rightAnswer];
      let limit = 30;
      var max = filteredWords.length <= 3 ? filteredWords.length : 3;
      for (var i = 0; i < max; i++) {
        const randomAnswer = this.getRandomWord(filteredWords, false, limit);
        const ids = answers.map(a => a.objectID);
        ids.includes(randomAnswer.objectID) && max < limit
          ? max++
          : answers.push(randomAnswer);
      }
      console.log(answers);
      return answers;
    },

    async checkAnswerA(answer) {
      const { id, type, grammar } = this.$route.params;
      if (this.isClicked) return;
      this.isClicked = true;
      this.choosenId = answer.objectID;
      if (answer.heb === this.question.qWord.heb) {
        this.status = "right";
        this.WIN = this.WIN + 1;
        this.LOST = 0;
        this.playAudio(this.WIN);
        //this.playedItems[this.idx].isRight = true;
        // const newidx = this.currItems.findIndex(
        //   element => element.objectID === answer.objectID
        // );
        // this.currItems[newidx].know = this.currItems[newidx].know
        //   ? this.currItems[newidx].know + 1
        //   : 1;
        console.log("RIGHT!", this.WIN);
      } else {
        this.status = "wrong";
        this.WIN = 0;
        this.mistakes.push({ word: this.question.qWord, mistake: answer.heb });
        console.log(this.mistakes);
        // if (this.LOST != 2) {
        this.LOST = this.LOST + 1;
        // }
        this.playAudio(0);
        //this.playedItems[this.idx].isRight = false;
        // const newidx = this.currItems.findIndex(
        //   element => element.objectID === this.question.qWord.objectID
        // );
        // this.currItems[newidx].know = this.currItems[newidx].know
        //   ? this.currItems[newidx].know - 1
        //   : 0;
        // this.currItems[newidx].wrong = this.currItems[newidx].wrong
        //   ? this.currItems[newidx].wrong + 1
        //   : 1;
        console.log("WRONG!", this.WIN);
      }
      // const items = this.currItems.filter(
      //   item => item.know < this.WIN || !item.know
      // );
      if (this.WIN < 8) {
        this.showNext = true;
      } else {
        // confetti({
        //   particleCount: 50,
        //   spread: 70,
        //   origin: { y: 0.6 },
        //   ticks: 200
        // });
        this.submitting = true;

        if (this.data) {
          await userService.finishLesson(this.data.id, this.user);
          await userService.finishGame(this.data.game.id);
        }
        if (this.user)
          if (this.data)
            this.updateUser = await userService.updateRules([
              { external_id: this.data.game.algolia_game_id, score: 4 }
            ]);
          else if (this.externalData)
            this.updateUser = await userService.updateRules([
              { external_id: this.$route.params.gameid, score: 4 }
            ]);
        if (
          this.externalData &&
          Object.keys(this.externalData).length &&
          this.user
        )
          await userService.finishGame(this.externalData.id);
        this.submitting = false;
        this.showResults = true;
        // this.playAudio(10);
      }
      // if (this.idx + 1 == this.chapter.questionsNumber) {
      //   this.showResults = true;
      // }
    },
    nextQuestion() {
      this.choosenId = null;
      this.isClicked = false;
      this.idx++;
      this.showNext = false;
      this.playAudio();
      this.generateQuestion(this.question.qWord);
    },
    randomList(answers) {
      return answers.sort(() => {
        return 0.5 - Math.random();
      });
    },
    showSummary() {
      const { id, type, grammar } = this.$route.params;
      let progress = 0;
      const items = this.playedItems;
      items.forEach(item => {
        if (item.isRight) {
          progress += 1;
        }
      });
      progress = (progress / this.playedItems.length) * 100;
      const rightItems = this.playedItems.filter(i => i.isRight);
      (this.isSummary = true), (this.showResults = false);
      this.msg = this.$t("grammarGame.game-page.welldone");
      if (!this.user) return;
    },
    restartGame() {
      this.mistakes = [];
      this.init();
    }
  },
  components: {
    ProgressBar,
    AudioBtn,
    GameSummary,
    GameHeader,
    OnBoardingModal
  }
};
</script>

<style scoped>
button {
  border: none;
}

.question {
  margin: 10px;
}

</style>



// WEBPACK FOOTER //
// game-page.vue?27e9c08c